import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Modal, { ModalVariants } from '../UI/Modal';

type ConfirmationModalType = {
  title: string;
  description: string;
  onSubmit: () => void;
  isLoading?: boolean;
  variant?: ModalVariants;
  confirmBtnText: string;
};
const ConfirmationModal = NiceModal.create(
  ({
    title,
    description,
    onSubmit,
    variant,
    isLoading,
    confirmBtnText,
  }: ConfirmationModalType) => {
    const modal = useModal();
    return (
      <Modal
        variant={variant}
        title={title}
        description={description}
        onSubmit={onSubmit}
        isLoading={isLoading}
        visible={modal.visible}
        onCancel={() => modal.hide()}
        withFooter={true}
        confirmBtnText={confirmBtnText}
        size="lg"
      />
    );
  }
);

export default ConfirmationModal;
